import { TFunction } from 'i18next';
import { CombinedText, DTableColumnsType } from '@darwin-ui';
import { Checkbox } from 'antd';
import { DarwinInput } from 'components/darwin-ui';
import { translateField } from 'utils/common';
import { DataSourceField } from 'types/dataSourcesTypes';

export const getColumns = (
  t: TFunction,
  searchQuery: string,
  mappedValues: Record<string, string>,
  onMappedChange: (fieldId: string, value: string) => void
): DTableColumnsType<DataSourceField> => {
  const columns: DTableColumnsType<DataSourceField> = [
    {
      title: t('data-sources.fields-view.columns.name'),
      dataIndex: 'name',
      key: 'name',
      render: (_, rowData) => {
        return (
          <span
            style={{
              fontWeight: rowData.isRequired ? 600 : 400,
            }}
          >
            <CombinedText
              lines={1}
              text={translateField(t, rowData.fieldKey, {
                subKey: 'field_name',
                by: 'key',
              })}
              highlight={searchQuery}
            />
          </span>
        );
      },
    },
    {
      title: t('data-sources.fields-view.columns.mapped-name'),
      dataIndex: 'mappedColumnName',
      key: 'mappedColumnName',
      sorter: false,
      render: (_: unknown, rowData: DataSourceField) => {
        const value =
          mappedValues[rowData.id] ?? rowData.sourceColumnName ?? '';

        return (
          <DarwinInput
            value={value}
            onChange={e => onMappedChange(rowData.id, e.target.value)}
          />
        );
      },
    },
    {
      title: t('data-sources.fields-view.columns.type'),
      dataIndex: 'fieldType',
      key: 'fieldType',
      render: type => {
        const typeLowerCase = type?.toLocaleLowerCase();
        const text = t(`data-tables.field-types.${typeLowerCase}`);
        return <CombinedText lines={1} text={text} highlight={searchQuery} />;
      },
    },
    {
      title: t('data-sources.fields-view.columns.required'),
      dataIndex: 'isRequired',
      key: 'isRequired',
      align: 'center',
      render: isRequired => <Checkbox checked={isRequired} disabled={true} />,
    },
  ];
  return columns;
};
